<template>
  <div>
    <div class="auth-page__form__header">
      <h2>Sign Up</h2>
    </div>
    <form
      @submit.prevent="handleSubmit()"
      class="auth-page__form__body"
    >
      <div
        :class="{'has-error': $v.name.first.$error}"
        class="form-group"
      >
        <label
          class="sr-only"
          for="inputFirst"
        >First Name</label>
        <input
          autofocus
          class="form-control"
          id="inputFirst"
          placeholder="First Name"
          type="text"
          v-model.trim="$v.name.first.$model"
        >
        <small
          class="error"
          v-show="$v.name.first.$error"
        >
          <template v-if="!$v.name.first.required">First Name is required.</template>
        </small>
      </div>

      <div
        :class="{'has-error': $v.name.last.$error}"
        class="form-group"
      >
        <label
          class="sr-only"
          for="inputLast"
        >Last Name</label>
        <input
          class="form-control"
          id="inputLast"
          placeholder="Last Name"
          type="text"
          v-model.trim="$v.name.last.$model"
        >
        <small
          class="error"
          v-show="$v.name.last.$error"
        >
          <template v-if="!$v.name.last.required">Last Name is required.</template>
        </small>
      </div>
      <div
        :class="{'has-error': $v.email.$error}"
        class="form-group"
      >
        <label
          class="sr-only"
          for="inputEmail"
        >Email</label>
        <input
          class="form-control"
          id="inputEmail"
          placeholder="Email address"
          type="email"
          v-model.trim="$v.email.$model"
        >
        <small
          class="error"
          v-show="$v.email.$error"
        >
          <template v-if="!$v.email.required">Email is required.</template>
          <template v-else-if="!$v.email.email">Invalid email.</template>
        </small>
      </div>
      <div
        :class="{'has-error': $v.password.$error}"
        class="form-group"
      >
        <label
          class="sr-only"
          for="inputPassword"
        >Password</label>
        <input
          class="form-control"
          id="inputPassword"
          placeholder="Password"
          type="password"
          v-model="$v.password.$model"
        >
        <small
          class="error"
          v-show="$v.password.$error"
        >
          <template v-if="!$v.password.required">Password is required.</template>
          <template v-else>
            Minimum 8 characters with at least 1 letter,
            1 number and 1 special character
          </template>
        </small>
      </div>
      <div
        :class="{ 'has-error': $v.confirmPassword.$error }"
        class="form-group"
      >
        <label
          class="sr-only"
          for="inputConfirmPassword"
        >Confirm Password</label>
        <input
          class="form-control"
          id="inputConfirmPassword"
          placeholder="Confirm Password"
          type="password"
          v-model="$v.confirmPassword.$model"
        >
        <small
          class="error"
          v-show="$v.confirmPassword.$error"
        >
          <template>Confirm password must be same as password</template>
        </small>
      </div>
      <div class="auth-page__form__submit-row">
        <div></div>
        <div>
          <span class="alternate-auth-link">Have an account?
            <router-link to="login">Log In</router-link>
          </span>
          <button
            @click="handleSubmit()"
            class="btn btn-primary"
            type="button"
          >Sign Up</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import API from '@/api';
import {
  required, minLength, email, sameAs,
} from 'vuelidate/lib/validators';
import passwordComplexity from '@/validators/password-complexity';

export default {
  data() {
    return {
      name: {
        first: '',
        last: '',
      },
      email: '',
      password: '',
      confirmPassword: '',
    };
  },
  validations: {
    name: {
      first: { required },
      last: { required },
    },
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(8),
      passwordComplexity,
    },
    confirmPassword: {
      sameAsPassword: sameAs('password'),
    },
  },
  methods: {
    handleSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const payload = {
          firstname: this.name.first,
          lastname: this.name.last,
          email: this.email,
          password: this.password,
        };
        API.createUser(payload).then(() => {
          this.$toast('success', 'Please login to your new account!');
          this.$router.push({ path: 'login' });
        })
          .catch((error) => {
            this.$toast('error', error.message);
          });
      }
    },
  },
};
</script>

<style lang="scss">
.signup-form {
  padding: 24px;
  background: #ffffff;
}

.form-body {
  padding-top: 1.5rem;
}
</style>
